<template>
	<section
		class="testimonial_column"
		:style="cssVars"
	>
		<div class="container">
			<div
				class="testimonial_column__inner"
				:class="{'one': parsedTestimonials.length === 1, 'two': parsedTestimonials.length === 2, 'three': parsedTestimonials.length === 3, 'four': parsedTestimonials.length === 4}"
			>
				<div
					class="testimonial_column__inner__text"
					v-for="(testimonial, index) in parsedTestimonials"
					:key="index"
					data-aos="fade-up"
					data-aos-duration="300"
					:data-aos-offset="50"
					:data-aos-delay="index * 50"
					:style="{'--background-colour': testimonial.background_colour, '--text-colour': testimonial.quote_colour, '--title-colour': testimonial.title_colour, '--tile-border': testimonial.background_colour === '#fff' ? '1px' : '0px'}"
				>

					<div class="content_container">
						<quote-icon></quote-icon>

						<div
							class="text"
							v-if="testimonial.quote"
							v-html="testimonial.quote"
						></div>

						<h5
							v-if="testimonial.quote_source"
							v-html="testimonial.quote_source"
						></h5>

						<img
							v-if="testimonial.logo"
							:src='testimonial.logo.url'
							:alt='testimonial.quote_source'
						/>
					</div>

				</div>
			</div>
		</div>
	</section>
</template>

<script>
import QuoteIcon from './QuoteIcon.vue';

export default {
	data() {
		return {
			theModalStatus: false,
		};
	},

	props: {
		title: {},
		text: {},
		primary_button: {},
		secondary_button: {},
		text_alignment: {},
		size: {},
		background_colour: {},
		text_colour: {},
		cta_theme: {},
		testimonials: {},
		data: {},
	},

	computed: {
		parsedTestimonials() {
			if (this.testimonials) {
				return JSON.parse(this.testimonials);
			} else {
				return null;
			}
		},

		parsedData() {
			if (this.data) {
				return JSON.parse(this.data);
			} else {
				return null;
			}
		},

		cssVars() {
			return {
				'--size':
					this.parsedTestimonials.length <= 2 ? '3 / span 8' : '1 / span 12',
				'--background-colour': this.parsedData.background_colour
					? this.parsedData.background_colour
					: '#D4C8B2',
				'--padding-top': this.parsedData.padding_top
					? this.parsedData.padding_top + 'px'
					: '64px',
				'--padding-bottom': this.parsedData.padding_bottom
					? this.parsedData.padding_bottom + 'px'
					: '64px',
				'--padding-top-mobile': this.parsedData.padding_top_mobile
					? this.parsedData.padding_top_mobile + 'px'
					: '42px',
				'--padding-bottom-mobile': this.parsedData.padding_bottom_mobile
					? this.parsedData.padding_bottom_mobile + 'px'
					: '42px',
			};
		},
	},

	watch: {},

	methods: {
		getModalData(arg) {
			this.theModalStatus = arg;
			return arg;
		},
	},

	components: { QuoteIcon },

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.testimonial_column {
	overflow: hidden;
	padding-top: var(--padding-top);
	padding-bottom: var(--padding-bottom);
	background-color: var(--background-colour);

	@media (max-width: $mobile-xl) {
		padding-top: var(--padding-top-mobile);
		padding-bottom: var(--padding-bottom-mobile);
	}

	/* @media (max-width: $mobile-xl) {
		padding: 0;
	} */

	/* .container {
		@media (max-width: $mobile-xl) {
			padding: 0;
			margin: 0;
			max-width: 100%;
		}
	} */

	&__inner {
		display: grid;
		grid-template-columns: 1fr 1fr;
		column-gap: var(--spacer);
		grid-column: var(--size);

		&.one {
			grid-column: 3 / span 8;
			grid-template-columns: 1fr;

			@media (max-width: $mobile-xl) {
				grid-template-columns: 1fr;
				column-gap: 0;
				row-gap: calc(var(--spacer) + 10px);
				grid-column: span 4;
			}
		}

		&.two {
			grid-column: 2 / span 10;

			@media (max-width: $mobile-xl) {
				grid-template-columns: 1fr;
				column-gap: 0;
				row-gap: calc(var(--spacer) + 10px);
				grid-column: span 4;
			}
		}

		&.three {
			grid-template-columns: 1fr 1fr 1fr;

			@media (max-width: $mobile-xl) {
				grid-template-columns: 1fr;
				column-gap: 0;
				row-gap: calc(var(--spacer) + 10px);
				grid-column: span 4;
			}
		}

		&.four {
			grid-template-columns: 1fr 1fr 1fr 1fr;

			@media (max-width: $mobile-xl) {
				grid-template-columns: 1fr;
				column-gap: 0;
				row-gap: calc(var(--spacer) + 10px);
				grid-column: span 4;
			}
		}

		@media (max-width: $mobile-xl) {
			grid-template-columns: 1fr;
			column-gap: 0;
			row-gap: calc(var(--spacer) + 10px);
			grid-column: span 4;
		}

		&__text {
			grid-column: span 1;
			// background: #ededed 0% 0% no-repeat padding-box;
			opacity: 1;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			gap: 0;
			font: normal normal 300 18px/28px var(--primary-font-family);
			padding: 0;
			background: var(--background-colour);
			border-radius: 8px;
			position: relative;
			overflow: hidden;
			border: 1px solid var(--medium-grey);

			@media (max-width: $mobile-xl) {
				/* gap: var(--gutter-mobile); */
				order: 1;
				/* padding: var(--spacer) var(--spacer) calc(var(--spacer) + 10px); */
				/* border-radius: 0; */
			}

			.image {
				height: 56px;
				padding: 20px 20px 0;
				display: flex;
				justify-content: flex-start;

				img {
					min-height: 56px;
					min-width: 56px;
				}
			}

			.content_container {
				padding: 24px 20px;
				height: 100%;

				&.has-cta {
					padding-bottom: 0;
				}
			}

			h5 {
				color: var(--title-colour);
				margin: 0;
				margin-bottom: 32px;
				z-index: 10;
			}

			.text {
				&::v-deep {
					p {
						margin-bottom: 0;

						&:first-of-type {
							margin-top: 0;
						}

						&:last-of-type {
							margin-bottom: 32px;
						}
					}
				}
			}

			svg {
				margin-bottom: 32px;
				display: flex;
			}

			img {
				display: flex;
				max-width: 200px;
				max-height: 200px;
			}

			@media (max-width: $mobile-xl) {
				grid-column: 1 / span 4;
				// padding: 0 var(--spacer);

				h5 {
					text-align: left;
				}

				.the_subtitle {
					text-align: center;
				}
			}

			.wpforms-container-full,
			.wpcf7-form {
				margin-top: var(--spacer);
			}

			.the_subtitle {
				font: normal normal 800 18px/28px var(--primary-font-family);
				z-index: 10;

				&::v-deep {
					p {
						margin: 0;
						font: normal normal 800 18px/28px var(--primary-font-family);

						@media (max-width: $mobile-xl) {
							text-align: left;
						}
					}
				}
			}

			.quote {
				font: normal normal normal 14px/18px var(--primary-font-family);
				color: var(--text-colour);
				z-index: 10;

				&::v-deep {
					p {
						margin: 0 0 var(--spacer);
						font: normal normal normal 14px/18px var(--primary-font-family);
						color: var(--text-colour);

						&:last-of-type {
							margin: 0 0 0;
						}

						@media (max-width: $mobile-xl) {
							text-align: left;
						}
					}

					ul,
					ol {
						display: flex;
						flex-direction: column;
						margin: var(--gutter-tablet-desktop) 0 var(--gutter-tablet-desktop);
						padding: 0 0 0 12px;
						color: var(--text-colour);
						row-gap: 12px;

						li {
							font: normal normal normal 14px/18px var(--primary-font-family);
							color: var(--text-colour);

							&::marker {
								color: var(--text-colour);
							}
						}
					}
				}
			}

			.cta_container {
				margin-top: (56px - 16px);
				z-index: 10;
				padding: 0 20px 20px;

				@media (max-width: $mobile-xl) {
					margin-top: 32px;
					text-align: left;
					display: flex;
					flex-wrap: wrap;
					gap: var(--spacer-mobile);
				}

				.site_button {
					margin-right: 16px;
				}
			}

			.content_device {
				position: absolute;
				right: 0;
				bottom: 0;

				@media (max-width: $mobile-xl) {
					height: 112px;
				}
			}
		}
	}
}
</style>
